import {Menu, Product} from "@/data/entities/menu";
import {OptionGroup, ProductOption} from "@/data/entities/option";

export type OptionGroupsLookup = {
    options: Map<number, ProductOption>,
    // Number of products that use an option group
    productCountByGroup: Map<number, number>,
    // Number of option groups an option is in
    groupCountByOption: Map<number, number>,
};

const increment = (map: Map<number, number>, key: number) => map.set(key, (map.get(key) ?? 0) + 1);

export const createOptionGroupsLookup = (menu: Menu): OptionGroupsLookup => {
    const productCountByGroup = new Map<number, number>();
    menu.products.forEach((product: Product) =>
        product.optionGroupIds.forEach(groupId => increment(productCountByGroup, groupId)));

    const groupCountByOption = new Map<number, number>();
    menu.optionGroups.forEach((group: OptionGroup) =>
        group.optionIds.forEach(optionId => increment(groupCountByOption, optionId)));

    return {
        options: new Map(menu.options.map(option => [option.id, option])),
        productCountByGroup,
        groupCountByOption,
    };
};

/**
 * Option groups by name; groups with the same name by ID.
 */
export const sortOptionGroups = (optionGroups: OptionGroup[]): OptionGroup[] => (
    [...optionGroups].sort((a, b) => a.name.localeCompare(b.name, "nl") || a.id - b.id)
);